import classNames from "classnames";
import React from "react";
import { AddColorButton } from "../add-color-button";
import { SingleColorSwatch } from "../single-color-swatch";
import classes from "./new-color-swatches-scss";
const NewColorSwatches = ({
  colors,
  selectedColor,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  dataHook
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames(classes.container), "data-hook": dataHook }, colors.map((color) => /* @__PURE__ */ React.createElement(
    SingleColorSwatch,
    {
      key: color,
      fill: color,
      selectedColor,
      onClick: onColorSelected,
      onMouseEnter: onColorPreviewStart,
      onMouseLeave: onColorPreviewEnd
    }
  )), !!onAddClick && /* @__PURE__ */ React.createElement(AddColorButton, { onAddClick }));
};
export {
  NewColorSwatches
};
//# sourceMappingURL=new-color-swatches.js.map
